
const handleApiErr = (err:any) => {
    if(err.status===500 || err?.message?.includes('Network Error')){
        return false
    }
    return true
};
export default handleApiErr;
